export type PostEmployeeCompetenceApiResponse =
  | /** status 200 Standard response */ ({
      competenceId?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostEmployeeCompetenceApiArg = {
  body: {
    description: string;
    isActive: boolean;
  };
};
export type GetEmployeeCompetenceApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      description?: string | null;
      isActive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetEmployeeCompetenceApiArg = {
  /** Name */
  id: string;
};
export type DeleteEmployeeCompetenceApiResponse = unknown;
export type DeleteEmployeeCompetenceApiArg = {
  /** Name */
  id: string;
};
export type PatchEmployeeCompetenceApiResponse = unknown;
export type PatchEmployeeCompetenceApiArg = {
  /** Name */
  id: string;
  body: {
    description: string;
    isActive: boolean;
  };
};
export type PostEmployeeCompetenceSetAsActiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PostEmployeeCompetenceSetAsActiveApiArg = {
  competenceId: string;
};
export type PostEmployeeCompetenceSetAsInactiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PostEmployeeCompetenceSetAsInactiveApiArg = {
  competenceId: string;
};
export type GetEmployeeWorkCompetencesListApiResponse =
  | /** status 200 Standard response */ ({
      competences?: ({
        id?: string | null;
        description?: string | null;
        isActive?: boolean | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetEmployeeCompetenceIntegrationApiResponse =
  | {competenceId: string; contextTarget: 'PLANNER'; contextId: string}[]
  | null;
export type GetEmployeeCompetenceIntegrationApiArg = {
  competenceId?: string;
  contextTarget?: 'PLANNER';
  contextId?: string;
};
export type GetIntegrationCompetencesApiResponse =
  | {id: string; label?: string | null; isActive: boolean}[]
  | null;
export type DeleteEmployeeCompetenceLinkApiArg = {
  competenceId: string;
  contextTarget: 'PLANNER';
};
export type DeleteEmployeeCompetenceLinkApiResponse = unknown;
export type PutEmployeeCompetenceLinkApiArg = {
  competenceId: string;
  contextTarget: 'PLANNER';
  contextId: string;
};
export type PutEmployeeCompetenceLinkApiResponse = unknown;
